import { Bestellung, IdRequest, LoadState, RemoteResult } from "mangdto"
import BaseLogic from "../base_logic"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"

export default class BestellungLogic extends BaseLogic {
  bestellung?: Bestellung = null
  bestellungLoadState: LoadState = LoadState.Idle

  init(id: string) {
    this.bestellungLoadState = LoadState.Loading

    var request = new IdRequest()
    request.id = id

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungKundeDetails,
      request,
    )
      .then((response) => {
        if (response.data.success) {
          this.bestellungLoadState = LoadState.Completed
          this.mainLogic.bestellung = new Bestellung()
          this.mainLogic.bestellung = response.data.payload
        } else {
          this.bestellungLoadState = LoadState.Error
        }
      })
      .catch(() => {
        this.bestellungLoadState = LoadState.Error
      })
  }
}
